import React, { useEffect, useState } from "react";
import {
  Card,
  Button,
  Col,
  Container,
  Row,
  Table,
  Modal,
  ListGroup,
} from "react-bootstrap";
import WhatsAppAPI from "../../api/WhatsAppAPI";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import jwt_decode from "jwt-decode";
import { FaTrash, FaEdit, FaPlus } from "react-icons/fa";
import { ShimmerTable } from "../common/ShimmerTable";
const InteractiveMessage = ({ selectedWhatsAppSetting }) => {
  const [userInfo, setUserInfo] = useState(
    jwt_decode(sessionStorage.getItem("token")),
  );
  const navigate = useNavigate();
  const [body, setBody] = useState([]);
  const [isSpinner, setIsSpinner] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const docxIcon = "/user_images/doc-icon.png";
  const imgIcon = "/user_images/placeholder.jpg";

  useEffect(() => {
    fetchData(selectedWhatsAppSetting);
  }, [selectedWhatsAppSetting]);

  const fetchData = async (selectedWhatsAppSetting) => {
    try {
      const result = await WhatsAppAPI.fetchInteractiveMessage(
        selectedWhatsAppSetting,
      );
      if (result.success) {
        setBody(result.records);
      } else {
        setBody([]);
      }
    } catch (error) {
      setBody([]);
      // console.error('Error fetching data:', error);
    } finally {
      setIsSpinner(true);
    }
  };

  // Handle click on Name column to show WhatsApp-like UI
  const handleShowMessage = (message) => {
    setSelectedMessage(message);
    setModalShow(true);
  };

  // Define Table Headers
  const labels = { beforeSelect: " " };
  const header = [
    {
      title: "Name",
      prop: "name",
      isFilterable: true,
      cell: (row) => (
        <span
          className="text-primary cursor-pointer"
          onClick={() => handleShowMessage(row)}
        >
          {row.name || ""}
        </span>
      ),
    },
    {
      title: "Header Content",
      prop: "header_content",
      cell: (row) => row.header_content || "",
    },
    {
      title: "Body Text",
      prop: "body_text",
      cell: (row) =>
        row.body_text
          ? row.body_text.substring(0, 25) +
            (row.body_text.length > 25 ? "..." : "")
          : "",
    },
    {
      title: "Footer Text",
      prop: "footer_text",
      cell: (row) => row.footer_text || "",
    },
    {
      title: "Actions",
      prop: "id",
      cell: (row) => (
        <Button
          variant="outline-primary"
          size="sm"
          onClick={() => editRecord(row)}
        >
          <FaEdit />
        </Button>
      ),
    },
  ];

  const createRecord = () => {
    navigate("/interactive_message/add");
  };

  const editRecord = (data) => {
    navigate(`/interactive_message/${data.id}/e`, { state: data });
  };

  const renderHeader = () => {
    const fileUrl = selectedMessage?.file_id
      ? `/public/${userInfo.tenantcode}/attachment/${selectedMessage.file_title}`
      : imgIcon;

    switch (selectedMessage?.header_type) {
      case "image":
        return (
          <img
            src={fileUrl}
            alt="Template Header"
            className="img-fluid rounded w-100 mb-2"
            style={{ height: "200px", objectFit: "cover" }}
          />
        );
      case "video":
        return (
          <video
            src={fileUrl}
            controls
            className="img-fluid rounded w-100 mb-2"
            style={{ height: "200px", objectFit: "cover" }}
          />
        );
      case "document":
        return (
          <a href={fileUrl} target="_blank" rel="noopener noreferrer">
            <img
              src={docxIcon}
              alt="Document Thumbnail"
              className="img-fluid rounded w-100 mb-2"
              style={{ height: "200px", objectFit: "cover" }}
            />
          </a>
        );
      default:
        return (
          <h5 className="fw-bold text-dark">
            {selectedMessage?.header_content}
          </h5>
        );
    }
  };

  const renderFormattedMessage = () => {
    if (!selectedMessage?.body_text) return null;

    const formattedText = selectedMessage?.body_text.replace(
      /(\n)+/g,
      "<br />",
    );
    return <span dangerouslySetInnerHTML={{ __html: formattedText }} />;
  };

  const renderFooter = () =>
    selectedMessage?.footer_text && (
      <div className="template-footer text-muted mt-2">
        {selectedMessage.footer_text}
      </div>
    );

  const renderButtons = () =>
    selectedMessage?.buttons?.length > 0 && (
      <div className="template-buttons mt-3">
        {selectedMessage.buttons.map((btn, index) => (
          <Button key={index} variant="outline-secondary" className="me-2 mb-2">
            {btn.text}
          </Button>
        ))}
      </div>
    );

  const renderSections = () =>
    selectedMessage?.sections?.length > 0 && (
      <div className="template-sections mt-3">
        {selectedMessage.sections.map((section, idx) => (
          <div key={idx}>
            <h6 className="fw-bold mb-3">{section.title}</h6>
            <hr className="text-muted" />
            <div className="d-flex flex-wrap">
              {section.rows.map((row) => (
                <div key={row.id} className="form-check ms-4">
                  <input
                    type="radio"
                    className="form-check-input"
                    name={`section-${idx}`}
                    id={`row-${row.id}`}
                  />
                  <label className="form-check-label" htmlFor={`row-${row.id}`}>
                    {row.title}
                  </label>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );

  return (
    <>
      <Container className="mt-5">
        {/* <Row className='mx-5 text-center g-0'>
                    <Col lg={12}>
                        <div className='text-center p-2' style={{ height: '40px', backgroundColor: '#ffffff', borderRadius: '5px' }}>
                            <span className='fw-semibold p-1' style={{ color: '#605C68', fontSize: 'large' }}>
                                Quick Reply Records
                            </span>
                        </div>
                    </Col>
                </Row> */}

        <Row className="mx-5 mb-4">
          <Card className="p-4 header-bg shadow-sm border-0 rounded-3">
            <h5 className="mb-2 fw-bold">💡 Quick Guide</h5>
            <small>
              Quick Chat Tip: Start with a clear message tag to understand user
              interests. This helps you send timely, personalized replies and
              keep the conversation meaningful and engaging!
            </small>
          </Card>
        </Row>

        {/* {isSpinner ? (
        <Container className='mb-5'>
          <Row className='mx-5 g-0'>
            <Col lg={12} className="mb-3">
              <DatatableWrapper
                body={body}
                headers={header}
                paginationOptionsProps={{ initialState: { rowsPerPage: 10, options: [5, 10, 15, 20] } }}
              >
                <Row className="mb-2">
                  <Col lg={4} className="d-flex flex-col justify-content-end align-items-end">
                    <Filter />
                  </Col>
                  <Col lg={4} className="d-flex flex-col justify-content-start align-items-start">
                    <PaginationOptions labels={labels} />
                  </Col>
                  <Col lg={4} className="mt-2 d-flex flex-col justify-content-end align-items-end">
                    <Button className="btn btn-sm" variant="outline-secondary" onClick={createRecord}>
                      Add New Message
                    </Button>
                  </Col>
                </Row>
                <Table striped className="data-table" responsive="sm">
                  <TableHeader />
                  <TableBody />
                </Table>
                <Pagination />
              </DatatableWrapper>
            </Col>
          </Row>
        </Container>
      ) : (
        <div className="sk-cube-grid">
          <div className="sk-cube sk-cube1"></div>
          <div className="sk-cube sk-cube2"></div>
          <div className="sk-cube sk-cube3"></div>
          <div className="sk-cube sk-cube4"></div>
          <div className="sk-cube sk-cube5"></div>
          <div className="sk-cube sk-cube6"></div>
          <div className="sk-cube sk-cube7"></div>
          <div className="sk-cube sk-cube8"></div>
          <div className="sk-cube sk-cube9"></div>
        </div>
      )} */}

        <Row className="mx-5 g-0">
          <Col lg={12} className="mb-3">
            <Row className="g-0">
              <Col lg={12}>
                <div className="bg-white shadow-sm border-0 rounded-3 p-4">
                  <h5 className="fw-semibold mb-1">📦 All Message</h5>

                  {isSpinner ? (
                    <DatatableWrapper
                      body={body}
                      headers={header}
                      paginationOptionsProps={{
                        initialState: {
                          rowsPerPage: 10,
                          options: [5, 10, 15, 20],
                        },
                      }}
                    >
                      <Row className="mb-3">
                        <Col
                          lg={3}
                          sm={10}
                          xs={10}
                          className="d-flex flex-col justify-content-end align-items-end"
                        >
                          <Filter className="p-2" />
                        </Col>
                        <Col
                          lg={4}
                          sm={2}
                          xs={2}
                          className="d-flex flex-col justify-content-start align-items-start"
                        >
                          <PaginationOptions labels={labels} />
                        </Col>
                        <Col
                          lg={5}
                          sm={12}
                          xs={12}
                          className="mt-2 d-flex flex-col justify-content-end align-items-end"
                        >
                          <Button
                            className="btn btn-sm"
                            variant="outline-secondary"
                            onClick={createRecord}
                          >
                            <FaPlus /> Add New Message
                          </Button>
                        </Col>
                      </Row>

                      <div className="table-responsive">
                        <Table
                          striped
                          bordered
                          className="related-list-table"
                          responsive="sm"
                        >
                          <TableHeader />
                          <TableBody />
                        </Table>
                      </div>
                      <Pagination />
                    </DatatableWrapper>
                  ) : (
                    <ShimmerTable row={10} col={4} />
                  )}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      {/* WhatsApp-like UI Modal */}
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        backdrop="static"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {selectedMessage?.name || "Quick Reply"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedMessage && (
            <>
              <Card>
                <Card.Body>
                  <div className="whatsapp-background w-100">
                    <div className="template-box">
                      {renderHeader()}
                      <div className="template-content">
                        {renderFormattedMessage()}
                        {renderFooter()}
                        {renderButtons()}
                        {renderSections()}
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>

              <div className="mt-4 text-end">
                <Button
                  variant="outline-secondary"
                  className="px-3 py-1 rounded-pill shadow-sm"
                  style={{ fontSize: "0.9rem" }}
                  onClick={() => editRecord(selectedMessage)}
                >
                  ✏️ Edit
                </Button>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>

      <ToastContainer />
    </>
  );
};

export default InteractiveMessage;
